// Service Icons - SVG Icons for each service

export const BrandIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="12" r="4" fill={color}/>
    <path d="M12 2V6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 18V22" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M2 12H6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M18 12H22" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export const SoftwareIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="20" height="14" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M8 21H16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 17V21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 8L10 10L7 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 12H17" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export const AIIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" rx="2" stroke={color} strokeWidth="2"/>
    <circle cx="9" cy="10" r="1.5" fill={color}/>
    <circle cx="15" cy="10" r="1.5" fill={color}/>
    <path d="M9 15C9 15 10.5 17 12 17C13.5 17 15 15 15 15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 1V4" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 20V23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M1 12H4" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 12H23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export const TransformIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const UXIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="7" height="7" rx="1" stroke={color} strokeWidth="2"/>
    <rect x="14" y="3" width="7" height="7" rx="1" stroke={color} strokeWidth="2"/>
    <rect x="3" y="14" width="7" height="7" rx="1" stroke={color} strokeWidth="2"/>
    <circle cx="17.5" cy="17.5" r="3.5" stroke={color} strokeWidth="2"/>
  </svg>
)

export const DataIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 20V10" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 20V4" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 20V14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 20H21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export const MarketingIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 12H18L15 21L9 3L6 12H2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const SecurityIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12L11 14L15 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const HardwareIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="20" height="14" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M6 21H18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M10 17L8 21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 17L16 21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export const ConsultingIcon = ({ color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 10V6C22 4.89543 21.1046 4 20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H10" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="17" cy="17" r="5" stroke={color} strokeWidth="2"/>
    <path d="M17 14V17L19 18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 8H14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 12H10" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export const PowerIcon = () => (
  <img src="/power-logo.png" alt="Power Solutions" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
)

// Map of service IDs to their icon components
const serviceIconMap = {
  brand: BrandIcon,
  software: SoftwareIcon,
  ai: AIIcon,
  transform: TransformIcon,
  ux: UXIcon,
  data: DataIcon,
  marketing: MarketingIcon,
  security: SecurityIcon,
  hardware: HardwareIcon,
  consulting: ConsultingIcon,
  power: PowerIcon,
}

export const getServiceIcon = (serviceId, color) => {
  const IconComponent = serviceIconMap[serviceId]
  return IconComponent ? <IconComponent color={color} /> : null
}

export default serviceIconMap
